
import i18n from '@/locales/init'; 
export interface IAnalyzeGeneratorProps {
  display_answer: string;
  ai_analyze: string;

  // 阅读
  key_locating_words?: Array<{
    locating_word: string;
    syn_ary: Array<{
      synonym: string;
      target_sen: any[];
    }>;
  }>;
  central_sentences?: Array<{
    target_para: number;
    index: number;
    length: number;
    sentence: string; // 英文
    translation: string;
  }>;

  // 听力
  audio?: {
    start_time: number;
    end_time: number;
  };

}

export interface Location {
  index: number;
  length: number;
  target_para: any[] | boolean | number | number | { [key: string]: any; } | null | string;
}

export interface Analyze {
  content: string;
  location: Location[] | { start_time: number; end_time: number; } | null;
  type: string;
}

// 换行
const getBreakNode = () => {
  return {
    type: 'break',
    content: '',
    location: null,
  };
};

// 核心词
const getKeyWord = (items: IAnalyzeGeneratorProps['key_locating_words']): Analyze[] => {
  const result: Analyze[] = [];
  if (!items || items.length === 0) {
    return result;
  }
  result.push({
    type: 'header',
    content: `${i18n.t('common.dauyan_core_words')}:`,
    location: null,
  }, getBreakNode(), {
    type: 'text',
    content: items.map((item) => item.locating_word).join('; '),
    location: null,
  }, getBreakNode());

  return result;
};

// 文中同义替换
const getKeywordsList = (items: IAnalyzeGeneratorProps['key_locating_words']): Analyze[] => {
  const result: Analyze[] = [];

  if (!items || items.length === 0) {
    return result;
  }

  result.push(
    {
      type: 'header',
      content: `${i18n.t('common.dauyan_essay_same_replace')}:`,
      location: null,
    }, getBreakNode()
  );

  items.forEach((item, itemIndex) => {
    result.push({
      // eslint-disable-next-line no-irregular-whitespace
      content: i18n.t('common.dauyan_question_value_essay', {v: item.locating_word}),
      type: 'text',
      location: null,
    });

    item.syn_ary.forEach((syn, synIndex) => {
      if (synIndex !== 0) {
        result.push({
          type: 'text',
          content: ' & ',
          location: null,
        });
      }
      result.push({
        type: 'reference',
        content: syn.synonym,
        location: syn.target_sen.map((ele: any) => {
          return {
            ...ele,
            target_sen: '',
          };
        }),
      });
    });

    result.push(getBreakNode());
  });
  return result;
};

// 原文及翻译
const getTranslateList = (items: IAnalyzeGeneratorProps['central_sentences']): Analyze[] => {
  const result: Analyze[] = [];
  if (!items || items.length === 0) {
    return result;
  }

  result.push({
    type: 'header',
    content: `${i18n.t('common.dauyan_origin_essay_and_translate')}:`,
    location: null,
  }, getBreakNode());

  items.forEach((item, index) => {
    result.push({
      type: 'reference',
      content: item.sentence,
      location: [{
        index: item.index,
        length: item.length,
        target_para: item.target_para,
      }],
    }, getBreakNode(), {
      type: 'text',
      content: item.translation,
      location: null,
    });
  });

  return result;
};

// ai解析
const getAIAnalyze = (ai_analyze: string) => {
  const result = [{
    type: 'header',
    content: `${i18n.t('common.dauyan_question_analysis')}:`,
    location: null,
  }, getBreakNode()];

  const list = ai_analyze.split('\n');

  list.forEach((s, index) => {
    if (!s) {
      return;
    }
    result.push({
      content: s,
      type: 'text',
      location: null,
    });
    if (index < list.length - 1) {
      result.push(getBreakNode());
    }
  });

  return result;
};

const getAudioList = (audio: IAnalyzeGeneratorProps['audio']): Analyze[] => {
  if (!audio) {
    return [];
  }
  return [{
    type: 'header',
    content: `${i18n.t('common.dauyan_audio_source')}:`,
    location: null,
  }, getBreakNode(), {
    type: 'audio',
    content: '',
    location: {
      start_time: audio.start_time,
      end_time: audio.end_time,
    },
  }, getBreakNode()
  ];
};


export const analyzeGenerator = (q: IAnalyzeGeneratorProps) => {
  const result: Analyze[] = [];
  console.log(q.display_answer);
  // 答案
  result.push({
    type: 'answer',
    content: i18n.t('common.dauyan_question_answer_v') + q.display_answer,
    location: null,
  }, getBreakNode());

  // 音频
  result.push(...getAudioList(q.audio));
  // 核心词
  result.push(...getKeyWord(q.key_locating_words));
  // 文中同义替换
  result.push(...getKeywordsList(q.key_locating_words));
  // 原文翻译
  result.push(...getTranslateList(q.central_sentences));
  // 解析
  result.push(...getAIAnalyze(q.ai_analyze));


  return result;
};
